<template>
  <div class="cont" ref="theform">
    <div class="alert alert-secondary" role="alert" v-if="day">
      Verification may take longer over the weekend, please bear with us.
    </div>
    <div class="row m-0">
      <div class="col-12 p-0" ref="profile_picture">
        <profile-picture @next="moveToNext"></profile-picture>
      </div>
      <div class="col-12 p-0" ref="social_verification">
        <social-verification @next="moveToNext"></social-verification>
      </div>
      <div class="col-12 p-0" ref="identity_verification">
        <identity-verification @next="moveToNext"></identity-verification>
      </div>
      <div class="col-12 p-0" ref="account_verification">
        <account-verification @next="moveToNext"></account-verification>
      </div>
      <div class="col-12 p-0" ref="referral_verification">
        <referral-verification @next="moveToNext"></referral-verification>
      </div>
    </div>
    <div class="foot">
      <!-- <button class="btn btn-lg btn-default submit-button mx disabled">Skip For Now</button> -->
      <button class="btn btn-lg btn-success submit-button ignore mx" @click="saveAndContinue">{{ textOnButton }}</button>
    </div>
    <!-- <pre>{{ u }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import ProfilePicture from '@/components/Pages/Profile/ProfilePicture';
import SocialVerification from '@/components/Pages/Verification/Social';
import AccountVerification from '@/components/Pages/Verification/Account';
import ReferralVerification from '@/components/Pages/Verification/Referral';
import IdentityVerification from '@/components/Pages/Verification/Identity';

export default {
  name: 'basic-setup',
  components: {
    ProfilePicture,
    SocialVerification,
    AccountVerification,
    ReferralVerification,
    IdentityVerification,
  },
  data() {
    return {
      nots: [],
      r: [],
    };
  },
  computed: {
    u() {
      return this.$auth.user();
    },
    day() {
      const today = new Date();
      const day = today.getDay();
      return day === 0 || day >= 5;
    },
    textOnButton() {
      if (this.u.verified) {
        return 'Move to next stage';
      }

      if (this.u.retry_verify) {
        return 'Re-verify';
      }

      return 'Verify';
    },
  },
  methods: {
    saveAndContinue() {
      this.$auth.fetch();
      if (!this.u.progress.pic) {
        return swal('Please complete the Profile Picture setup');
      }
      if (!this.u.progress.social) {
        return swal('Please setup your social accounts');
      }
      if (!this.u.progress.identity) {
        return swal('Please ensure you complete the Government Issued License setup');
      }
      if (!this.u.progress.account) {
        return swal('Please ensure you complete the Bank account verification');
      }
      if (!this.u.progress.referral) {
        return swal('Please ensure you complete the Referral verification');
      }
      if (!this.u.email_verified) {
        return swal({
          title: 'Email Verification',
          text: 'You have to verify your email address to proceed to the next stage.',
          buttons: ['Ok', 'Resend Verification Email ⨠'],
        }).then((value) => {
          if (value) {
            axios.post(`${BASE_API}/v1/tutor/verify_email/resend`, {
              action: 'resend-verification',
            })
              .then(() => swal('Verification Email sent'))
              .catch(() => swal('Failed to send verification email. Please Try again later.'));
          }
          return null;
        });
      }
      // if (!this.u.email_verified) {
      //   const nom = Math.floor((Math.random() * 10000) + 1000);
      //   this.nots.push({
      //     id: nom,
      //     read: false,
      //     type: 'error',
      //     content: 'Please wait 0-3 hours while the verification team goes through your application. You will be able to complete your registration once you have been verified. In the meantime, you can prepare for your online tests.  Thank you for your patience.'
      //   });
      //   this.r.push({
      //     id: nom,
      //     read: false,
      //     type: 'error',
      //     content: 'Please wait 0-3 hours while the verification team goes through your application. You will be able to complete your registration once you have been verified. In the meantime, you can prepare for your online tests.  Thank you for your patience.'
      //   });
      //   this.$nextTick(() => this.$refs.theform.scrollIntoView({
      //     behavior: 'smooth',
      //     block: 'start',
      //     inline: 'nearest',
      //   }));
      //   axios.post(`${BASE_API}/v1/tutor/verify-check`, { action: 'please-verify' });
      //   if (this.$route.query.reverify) {
      //     return this.$router.push({ name: 'verification-setup' });
      //   }
      //   return swal('Please wait 0-3 hours while the verification team goes through your application. You will be able to complete your registration once you have been verified. In the meantime, you can prepare for your online tests.  Thank you for your patience.');
      // }
      axios.post(`${BASE_API}/v1/tutor/steps`, { step: 'verification' })
        .then(() => {
          this.$auth.fetch();
          this.$store.dispatch('getUserTutor');
        });
      return this.$router.push({ name: 'availability-info' });
    },
    removeNotification(id) {
      const nots = this.r.findIndex(n => n.id === id);
      this.r[nots].read = true;
      this.nots.splice(nots, 1);
      const notifications = [];

      for (let notification of this.r) {
        notifications.push(notification);
      }

      this.$store.dispatch('updateNotifications', notifications)
        .then(response => console.log(response))
        .catch(response => swal('Failed', response, 'error'));
    },
    moveToNext() {
      if (!this.$auth.user().progress.pic) {
        return this.$nextTick(() => {
          this.$refs.profile_picture.scrollIntoView({
            behavior: 'smooth', block: 'start', inline: 'nearest',
          });
        });
      }

      if (!this.$auth.user().progress.social) {
        return this.$nextTick(() => {
          this.$refs.social_verification.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'nearest',
          });
        });
      }

      if (!this.$auth.user().progress.identity) {
        return this.$nextTick(() => {
          this.$refs.identity_verification.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'nearest',
          });
        });
      }

      if (!this.$auth.user().progress.account) {
        return this.$nextTick(() => {
          this.$refs.account_verification.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'nearest',
          });
        });
      }

      if (!this.$auth.user().progress.referral) {
        return this.$nextTick(() => {
          this.$refs.referral_verification.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'nearest',
          });
        });
      }

      return null;
    },
    listen() {
      Echo.channel(`tutor-${this.$auth.user().id}-notifications`)
        .listen('NewNotification', ({notification}) => {
          this.r.push(notification);
          this.nots.push(notification);
        });
    },
  },
  mounted() {
    if (this.$route.query.reverify) {
      this.saveAndContinue();
    }

    this.$auth.user().notification &&
    this.$auth.user().notifications.forEach((n) => {
      this.r.push(n);
      this.nots.push(n);
    });

    this.listen();
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.cont {
  padding: 15px 0;
}
.title {
  font-size: 18px;
  font-weight: 800;
  margin: 10px 0;
  svg {
    float: right;
    height: 18px;
    width: 18px;
    margin: 0 15px;
  }
}
p.subtitle {
  margin: 0 0 10px 0;
  color: #2A2A2A;
  font-size: 14px;
}
.submit-button {
  width: 130px;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  float: right;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  &.btn-default {
    box-shadow: 0 2px 2px 0 rgba(112, 112, 112, 0.14), 0 3px 1px -2px rgba(112, 112, 112, 0.12), 0 1px 5px 0 rgba(112, 112, 112, 0.2);
  }
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {box-shadow: none !important;}
  }
}
.mx { margin: 0 10px; }
.foot {
  margin-top: 30px;
}
@media only screen and (max-width: 600px) {
  .hold {margin-bottom: 35px; margin-top: 20px;}
  .title {font-size: 16px;}
  .submit-button:not(.ignore) {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 54px;
    float: left;
    left: 0;
    border-radius: 0;
    margin: 0;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Setup/Verification.vue